import { render, staticRenderFns } from "./formG.vue?vue&type=template&id=59cb5605&scoped=true"
import script from "./formG.vue?vue&type=script&lang=js"
export * from "./formG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cb5605",
  null
  
)

export default component.exports